export const HOME = '/';

export const ABOUT = '/about';
export const PROFILE = '/profile';
export const PROFILE_EDIT = `${PROFILE}/edit-profile`;
export const AI_ASSISTANT = '/ai-assistant';
